var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.524 17.447 14.326 3.209a2.694 2.694 0 0 0-4.652 0L1.476 17.447a2.57 2.57 0 0 0 0 2.598 2.65 2.65 0 0 0 2.326 1.33h16.396a2.65 2.65 0 0 0 2.325-1.33 2.57 2.57 0 0 0 .001-2.598m-1.95 1.472a.42.42 0 0 1-.375.206H3.802a.42.42 0 0 1-.375-.206.33.33 0 0 1 0-.35l8.198-14.238a.447.447 0 0 1 .75 0l8.198 14.238a.33.33 0 0 1 .001.35m-9.699-6.169v-3a1.125 1.125 0 1 1 2.25 0v3a1.125 1.125 0 1 1-2.25 0M13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};
export default SvgWarning;